export default __webpack_public_path__ + "c4cddb4eedfdaf8dcb1ff793fb2a9393.svg";